<div class="-oneX-container">
    <div class="-oneX-container">
        <div class="-oneX-row">
            <div class="-oneX-heading--h2">Claims Found</div>
        </div>
    </div>
    <hr>
    <div class="-oneX-container">
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container">   
                <app-claims-table></app-claims-table>
            </div>
        </div>
    </div>
    <hr>
    <div class="-oneX-container">
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-container">   
                <app-search-another-claim></app-search-another-claim>
            </div>
        </div>
    </div>
</div>